export default __webpack_public_path__ + "static/media/jfaulknerPortrait.7beb1553.png";